import React from 'react';
import PropTypes from 'prop-types';
import PartnerBurdenNum from './PartnerBurdenNum';

/**
 * 파트너 쿠폰 판매가 및 스킴
 */
function PartnerBurdenPrice({ isSkim, price }) {
  const priceOverText = TMON.htStaticData.isVisibleDelegatePriceOver
    ? '원~'
    : '원';
  return (
    <span className="partner_burden_price">
      {isSkim ? '' : '할인가 '}
      <PartnerBurdenNum isSkim={isSkim} price={price} />
      {isSkim ? '원 이상 구매 시' : priceOverText}
    </span>
  );
}

PartnerBurdenPrice.propTypes = {
  isSkim: PropTypes.bool,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PartnerBurdenPrice;
